import React, {useEffect, useState} from "react";
import {useSearchParam} from "react-use";
import {Button, Container} from "../components/common";
import {CBAction, CBBody, ContentBox} from "../components/common/ContentBox";
import {Redirect} from "react-router-dom";
import {getProvider} from "../services/api/idpProxyApi";

const oktaDomain = process.env.REACT_APP_OKTA_DOMAIN;

const checkIdpAutoLink = async (code, error, state) => {
    const autoLink = !!code && /User creation was disabled/gi.test(error);
    if (autoLink) {
        const provider = await getProvider(code);
        return provider.data
    }
}

const IdpErrorView = () => {
    const code = useSearchParam('code');
    const state = useSearchParam('state');
    const error = useSearchParam('error');
    const errorDesc = useSearchParam('error_description');
    const [provider, setProvider] = useState(null);

    const backToLoginPage = () => {
        window.location.href = 'https://' + oktaDomain;
    }

    useEffect(() => {
        (async () => {
            const provider = await checkIdpAutoLink(code, error, state);
            setProvider(provider);
        })();
    });

    if(provider){
        return <Redirect to={{
            pathname: `/idp/link/${provider}`,
            search: `?code=${code}&state=${state}`,
        }} />
    }

    return (
        <Container>
            <h1>Error</h1>

            <ContentBox>
                <CBBody>
                    <p>Error: {error}</p>

                    <p>Error description: {errorDesc}</p>

                    <p>request state: {state}</p>

                    {/*<Link to={'/auth/google/login'}>Link Google (Test)</Link>*/}

                    <CBAction>
                        <Button type={'submit'} onClick={backToLoginPage}>Back</Button>
                    </CBAction>
                </CBBody>
            </ContentBox>
        </Container>
    );
}

export default IdpErrorView;

